package modysy.simulation.collision

import modysy.datastructures.Vector2

/** Stores the information about the collision.
  *
  * @param point       The point where the collision occurs.
  * @param normal      The collision normal.
  * @param penetration The collision penetration, specifying how deep one object is inside of the other object. */
case class CollisionSpot(point: Vector2, normal: Vector2, penetration: Double)



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/collision/CollisionSpot.scala